import { render, staticRenderFns } from "./administrationNoticeModal.vue?vue&type=template&id=7f324d02"
import script from "./administrationNoticeModal.vue?vue&type=script&lang=js"
export * from "./administrationNoticeModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports